/**
 * Shared Components
 * Export all reusable components from this file
 */

import React from 'react';
import MediaCard from './MediaCard';
import StepItem from './StepItem';
import FaqItem from './FaqItem';
import PressCard from './PressCard';
import PostControlButtons from './PostControlButtons';
import BranchDetailsCard, {getInfoText } from './BranchDetailsCard';
import BranchGrid from './BranchGrid';
import NotificationIndicator from './NotificationIndicator';

export {
    MediaCard, StepItem, FaqItem, PressCard,
    PostControlButtons, BranchDetailsCard, BranchGrid, getInfoText, NotificationIndicator
};


export const getPostTypeComponent = (postType, post) => {
    switch (postType) {
        case 'media':
            return <MediaCard key={post.id} media={post} />;
        case 'step':
            return <StepItem key={post.id} step={post} />;
        default:
            return (
                <>
                    <div className="__post-image">
                        {post.image && <img src={post.image} alt={post.title} />}
                    </div>
                    <div className="__post-content" style={{ flex: 1, minWidth: 0 }}>
                        <h5 style={{ margin: 0, fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                            dangerouslySetInnerHTML={{ __html: post.title }} />
                        {post.content && <div dangerouslySetInnerHTML={{ __html: post.content }} />}
                    </div>
                </>
            );
    }
};

